import { useEffect, useState, type ReactNode } from 'react';
import type { Me, Site, TenantSummary } from '@iot-dashboard/shared';
import type { NavSection } from './nav';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

interface Props {
  me: Me;
  mspName: string;
  tenant?: TenantSummary;
  sites?: Site[];
  sections: NavSection[];
  children: ReactNode;
}

export function AppShell({ me, mspName, tenant, sites, sections, children }: Props) {
  const [open, setOpen] = useState(false);

  // While the drawer is over the page, Escape closes it and the page behind it
  // must not scroll away under the finger.
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = previous;
    };
  }, [open]);

  return (
    <div className={`shell${open ? ' shell--drawer-open' : ''}`}>
      <TopBar me={me} tenant={tenant} mspName={mspName} onToggleSidebar={() => setOpen((o) => !o)} drawerOpen={open} />
      <Sidebar me={me} tenant={tenant} sites={sites} sections={sections} open={open} onNavigate={() => setOpen(false)} />
      {open ? <button type="button" className="scrim" aria-label="Close navigation" onClick={() => setOpen(false)} /> : null}
      <main className="main">{children}</main>
    </div>
  );
}
